// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UserDeleteOutlinedSvg from "@fishx/icons-svg/es/asn/UserDeleteOutlined";
import FishxIcon from '../components/FishxIcon';

var UserDeleteOutlined = function UserDeleteOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UserDeleteOutlinedSvg
  }));
};

UserDeleteOutlined.displayName = 'UserDeleteOutlined';
export default React.forwardRef(UserDeleteOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UserDeleteOutlined.js
// module id = 4341
// module chunks = 0